var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSec1Icon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sec1Icon3",
    transform: "translate(-480 -478)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_4846",
    "data-name": "\\uC0AC\\uAC01\\uD615 4846",
    width: 50,
    height: 50,
    rx: 12,
    transform: "translate(480 478)",
    fill: "#eaf0f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "engineering",
    transform: "translate(491 489)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33700",
    "data-name": "\\uD328\\uC2A4 33700",
    d: "M28,14.937V13.062a.423.423,0,0,0-.32-.41l-1.49-.373a12.223,12.223,0,0,0-.772-2.886l1.1-1.066a.423.423,0,0,0,.072-.515l-.938-1.624a.423.423,0,0,0-.482-.195L23.7,6.415A12.384,12.384,0,0,0,21.584,4.3l.423-1.477a.422.422,0,0,0-.195-.482l-1.624-.938a.423.423,0,0,0-.515.072l-1.066,1.1a12.223,12.223,0,0,0-2.886-.772L15.347.32a.422.422,0,0,0-.41-.32H13.062a.422.422,0,0,0-.41.32l-.373,1.49a12.223,12.223,0,0,0-2.886.772l-1.066-1.1a.423.423,0,0,0-.515-.072l-1.624.938a.423.423,0,0,0-.195.482L6.415,4.3A12.384,12.384,0,0,0,4.3,6.415L2.826,5.993a.422.422,0,0,0-.482.195L1.407,7.812a.423.423,0,0,0,.072.515l1.1,1.066a12.223,12.223,0,0,0-.772,2.886l-1.49.372a.422.422,0,0,0-.32.41v1.875a.422.422,0,0,0,.32.41l1.49.373a12.223,12.223,0,0,0,.772,2.886l-1.1,1.066a.423.423,0,0,0-.072.515l.938,1.624a.423.423,0,0,0,.482.195L4.3,21.584A12.384,12.384,0,0,0,6.415,23.7l-.423,1.477a.422.422,0,0,0,.195.482l1.624.938a.423.423,0,0,0,.515-.072l1.066-1.1a12.223,12.223,0,0,0,2.886.772l.373,1.49a.423.423,0,0,0,.41.32h1.875a.423.423,0,0,0,.41-.32l.373-1.49a12.223,12.223,0,0,0,2.886-.772l1.066,1.1a.423.423,0,0,0,.515.072l1.624-.938a.423.423,0,0,0,.195-.482L21.584,23.7A12.384,12.384,0,0,0,23.7,21.584l1.477.423a.422.422,0,0,0,.482-.195l.938-1.624a.423.423,0,0,0-.072-.515l-1.1-1.066a12.223,12.223,0,0,0,.772-2.886l1.49-.373a.423.423,0,0,0,.32-.41ZM14,22.929A8.929,8.929,0,1,1,22.929,14,8.929,8.929,0,0,1,14,22.929Z",
    fill: "#4673a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33701",
    "data-name": "\\uD328\\uC2A4 33701",
    d: "M248.5,60v2.535a8.084,8.084,0,0,1,0,16.168v2.535A10.619,10.619,0,1,0,248.5,60Z",
    transform: "translate(-234.501 -56.62)",
    fill: "#305786"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33702",
    "data-name": "\\uD328\\uC2A4 33702",
    d: "M79.548,70.619c0-5.865-4-10.619-8.929-10.619a10.619,10.619,0,1,0,0,21.239C75.551,81.239,79.548,76.484,79.548,70.619ZM66.976,64.354a7.254,7.254,0,0,1,6.793-.21,1.126,1.126,0,0,1,.295,1.806l-1.777,1.777a3.386,3.386,0,0,0-3.435,0l-2.047-2.047A.843.843,0,0,1,66.976,64.354Zm-2.9,9.485a7.257,7.257,0,0,1,0-6.4,1.126,1.126,0,0,1,1.806-.295l1.777,1.777a3.386,3.386,0,0,0,0,3.435L65.88,74.134A1.126,1.126,0,0,1,64.074,73.839Zm9.695,3.3a7.257,7.257,0,0,1-6.4,0,1.126,1.126,0,0,1-.295-1.806l1.777-1.777a3.386,3.386,0,0,0,3.435,0l1.777,1.777A1.126,1.126,0,0,1,73.769,77.135Zm1.49-3-1.777-1.777a3.386,3.386,0,0,0,0-3.435l2.047-2.047a.843.843,0,0,1,1.327.17,7.254,7.254,0,0,1,.21,6.793A1.126,1.126,0,0,1,75.259,74.134Z",
    transform: "translate(-56.62 -56.62)",
    fill: "#85a3c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33703",
    "data-name": "\\uD328\\uC2A4 33703",
    d: "M1.69,0A1.69,1.69,0,1,1,0,1.69,1.69,1.69,0,0,1,1.69,0Z",
    transform: "translate(12.309 12.309)",
    fill: "#eaf0f7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_8",
    "data-name": "\\uD0C0\\uC6D0 8",
    cx: 0.275,
    cy: 0.275,
    r: 0.275,
    transform: "translate(13.725 13.724)",
    fill: "#4673a9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec1Icon3);
export default __webpack_public_path__ + "static/media/sec1Icon3.add6af6ca7fa98d17aa98a5aef1c2dcb.svg";
export { ForwardRef as ReactComponent };